export class UpdateTimeOffHasFileDto {}
